import type { StateCreator } from "zustand" // move to lib/states
import { create } from "zustand" // move to lib/states
import { persist } from "zustand/middleware"

interface ThreadsMultiSelectState {
	threadIds: Array<string>
	toggleThreadId: (id: string) => void
	clearThreadIds: () => void
	bulkSelect: (ids: Array<string>) => void
}

const filterDefinition: StateCreator<ThreadsMultiSelectState> = (set, get) => ({
	threadIds: [],
	toggleThreadId: (id) => {
		const current = get().threadIds
		if (current.includes(id)) {
			set({ threadIds: current.filter((c) => c !== id) })
		} else {
			set({ threadIds: [...current, id] })
		}
	},
	clearThreadIds: () => {
		set({ threadIds: [] })
	},
	bulkSelect: (ids) => {
		set({ threadIds: ids })
	},
})

export const useThreadsMultiSelectState = create<ThreadsMultiSelectState>()(
	persist(filterDefinition, {
		name: "threads-multi-select",
	}),
)

export function useIsThreadsMultiSelectActive() {
	const isThreadsMultiSelectActive = useThreadsMultiSelectState(
		(state) => state.threadIds.length > 0,
	)
	return { isThreadsMultiSelectActive }
}
